import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {i18n} from '../../Utility/Format';
import Calendar, {DatePicker} from '../Widgets/Calendar';
import Switch from '../Controls/Switch';
import Button from '../Controls/Button';
import Icon from '../Helper/Icon';
import moment from 'moment';

const isDateDisabled = (date) => {
    if (!date){
        return false;
    }
    return date.isAfter(moment());
}

export default class SettlementOptionsContent extends Component {
    static propTypes = {
        options: PropTypes.object.isRequired,
        locale: PropTypes.string.isRequired,

        onFixingDateSelect: PropTypes.func.isRequired,
        onFixingTypeChange: PropTypes.func.isRequired,
        onMenuToggle: PropTypes.func.isRequired,
        onReset: PropTypes.func.isRequired,
    };

    constructor() {
        super();
        this.state = {
            calendarVisible: false
        };
    }

    render() {
        const toggleCalendar = () => {
            this.setState({calendarVisible: !this.state.calendarVisible});
        };

        const selectFixingDate = (date) => {
            const dateString = date.format('YYYY-MM-DD');
            this.props.onFixingDateSelect(dateString);
        };

        const changeFixingType = () => {
            this.props.onFixingTypeChange(this.props.options.type === "FIRST" ? "SECOND" : "FIRST");
        };

        const toggleMenu = (e) => {
            this.props.onMenuToggle(e, this.props.options);
        };

        const resetOptions = () => {
            if (this.state.calendarVisible) toggleCalendar();
            this.props.onReset();
        };

        return (
            <div>
                <section>
                    <p>{i18n('dbm.settlements.options.fixingsAt')}</p>
                    <div className="settlement-options"> 
                        <DatePicker 
                            value={this.props.options.date ? moment(this.props.options.date, 'YYYY-MM-DD') : moment()} 
                            onClick={toggleCalendar} locale={this.props.locale}/>
                        <Switch
                            leftLabel={i18n('dbm.fixings.type.first')}
                            rightLabel={i18n('dbm.fixings.type.second')}
                            toggleOn={this.props.options.type !== "FIRST"} // on = right, off = left
                            onChange={changeFixingType}
                        />
                        <div>
                            { this.state.calendarVisible ?
                                <Calendar
                                    fullBorders={true}
                                    showToday={false}
                                    showDateInput={false}
                                    localeName={this.props.locale}
                                    showHighlights={false}
                                    onSelect={selectFixingDate}
                                    disabledDate={isDateDisabled}
                                /> : null
                            }

                        </div>
                        <small>
                            {i18n('dbm.settlements.options.fixingsAtFootnote')}
                        </small>
                    </div>
                </section>
                 <div className="drawerPanel__panel__content--footer">
                    <Button
                        onClick={(e) => toggleMenu(e)}>
                        <Icon name="check-lg" isCollapsed={true}/> {i18n('dbm.settlements.options.saveOptionsButton')}
                    </Button>
                    <Button
                        className="button button--borderless"
                        onClick={resetOptions}>
                        <Icon name="reset" isCollapsed={true}/> {i18n('dbm.settlements.options.resetOptionsButton')}
                    </Button>
                </div>
            </div>
        )
    }
};